import { useMemo } from 'react';

import { useTheme } from '@zenbusiness/zui/styles';
import dayjs from 'dayjs';
import PropTypes from 'prop-types';
import {
  LineChart,
  XAxis,
  YAxis,
  Line,
  CartesianGrid,
  ReferenceLine,
  ResponsiveContainer
} from 'recharts';

import { DATE_FORMAT } from '#client/constants/date';
import { xTickFormatter, yTickFormatter } from '#client/utils/chart';

import { COLOR_HISTORY_BALANCE } from '../constants/colors';

const MAX_BALANCE = 400;
const NO_DATA_DAYS = 4;
const INTERVAL = 0;

export default function EmptyChart({ title = '', height = 200 }) {
  const theme = useTheme();

  const dailyBalance = useMemo(() => {
    const today = dayjs(new Date());
    const balanceData = [];

    for (let i = NO_DATA_DAYS; i >= 1; i -= 1) {
      const date = today.subtract(i, 'day').format(DATE_FORMAT.CHART);
      const amount = i === 1 ? MAX_BALANCE : 0;
      balanceData.push({ date, amount });
    }

    return balanceData;
  }, []);

  return (
    <ResponsiveContainer
      debounce={100}
      height={height}
      width="100%"
    >
      <LineChart
        data={dailyBalance}
        margin={{
          top: 10,
          right: 20,
          left: 0,
          bottom: 0
        }}
      >
        <CartesianGrid
          horizontal={false}
          stroke={COLOR_HISTORY_BALANCE.Y_TICK}
        />
        <XAxis
          axisLine={false}
          dataKey="date"
          interval={INTERVAL}
          style={{
            ...theme.typography.xs
          }}
          tickFormatter={xTickFormatter}
          tickLine={false}
        />
        <YAxis
          axisLine={false}
          domain={['auto', 'auto']}
          style={{
            ...theme.typography.xs
          }}
          tickFormatter={yTickFormatter}
          tickLine={false}
        />
        <ReferenceLine
          label={{
            ...theme.typography.xs,
            position: 'bottom',
            value: title,
            fill: COLOR_HISTORY_BALANCE.NO_DATA_TEXT
          }}
          stroke={COLOR_HISTORY_BALANCE.NO_DATA_LINE}
          strokeWidth={4}
          y={MAX_BALANCE / 2}
        />
        <Line
          dataKey="amount"
          dot={false}
          stroke={COLOR_HISTORY_BALANCE.LINE}
          strokeWidth={0}
          type="monotone"
        />
      </LineChart>
    </ResponsiveContainer>
  );
}

EmptyChart.propTypes = {
  title: PropTypes.string,
  height: PropTypes.number
};
